export default __webpack_public_path__ + "static/media/app-creator.3a188c96.webp";